<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer003">
<h1 class="title">Kissing Carrion</h1>
<h2 class="author">Gemma Files</h2>
<h2 class="author"><img alt="logo" class="_idGenObjectAttribute-1" src="image/logo2.jpg"/></h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// KissingCarrion.vue?267c1d40